import React from "react";
import fullDemoVideo from "./assets/cleversched.mp4";

import {
  Box,
  Typography,
} from "@mui/material";

import { NAVY } from "./colors";

export default function FullDemoPage() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#f5f7fb",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        px: 2,
        py: 4,
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontWeight: 900,
          color: NAVY,
          mb: 3,
          fontSize: { xs: 24, md: 32 },
          textAlign: "center",
        }}
      >
        Démonstration complète pour l’application CleverSched
      </Typography>

      {/* SIMPLE EMBEDDED VIDEO (NO MODAL) */}
      <Box
        sx={{
          width: "100%",
          maxWidth: "1200px",
          borderRadius: 3,
          overflow: "hidden",
          bgcolor: "#000",
          boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
          border: `3px solid ${NAVY}`,
        }}
      >
        <video
          controls
          playsInline
          preload="auto"
          style={{
            width: "100%",
            height: "auto",
            display: "block",
          }}
        >
          <source src={fullDemoVideo} type="video/mp4" />
          Votre navigateur ne supporte pas la vidéo HTML5.
        </video>
      </Box>
    </Box>
  );
}
